import { Button, Container, Text, VStack} from '@chakra-ui/react'
import { useNavigate } from 'react-router-dom'
import React from 'react'
import { useState } from 'react'
import { useAppDispatch, useAppSelector } from '../store/hooks.ts'
import { setID, setCondition } from './SurveySlice.ts'

const LANDING_TEXT = `Welcome! Through this platform, you will first take a photo of yourself to use as your Profile picture. 
                On the next page, please accept the browser dialogue asking to use your webcam, or you will be unable to participate in the study.\n
                After the camera loads, please spend some time to try out the camera. The "Capture" button will appear after you interact with the camera for 15 seconds.\n
                Once you are centered in the camera and ready, click “Capture” to capture your photo.\n\nNote: The camera may take a few moments to load.\n`

// URL Format: http://localhost:3000/?qualtricsid=value1234
let qualtricsID = "TEMP0000001"
let controlCondition = 1
const urlParams = new URLSearchParams(window.location.search);
const urlID = urlParams.get('qualtricsid')
const urlControl = urlParams.get('controlCondition')

if(urlID){
    qualtricsID = urlID
}

if(urlControl){
    controlCondition = urlControl
}


const LandingPage = () => {
    const navigate = useNavigate()
    const dispatch = useAppDispatch()

    dispatch(setID({qualtrics_id: qualtricsID}));
    dispatch(setCondition({control_condition: controlCondition}))

    return (
        <Container maxW={'container.xl'} py={12} centerContent={true} textAlign={'center'} paddingTop="15rem">
            <VStack spacing={'16px'} justifyContent={'space-between'}>
                <Text whiteSpace="pre-line" fontSize={"2xl"}>
                    {LANDING_TEXT}
                </Text>
                <Button colorScheme='blue' onClick={() => navigate(urlParams.get('filtertest') === '1' ? '/webcam?filtertest=1' : '/webcam')}>Continue</Button>
            </VStack>
        </Container>
  )
}

export default LandingPage
